import { ResourceOptions } from 'react-admin';
import { MdTune } from 'react-icons/md';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xbitRelayWithdrawalProviderConfigs;
export { XBIT_RELAY_WITHDRAWAL_PROVIDER_CONFIGS_PERMISSION_RESOURCE } from './constants';
export const icon = MdTune;
export const options: ResourceOptions = {
  label: 'module.xbitRelayWithdrawalProviderConfigs.title',
};
